<script>
  import {PlusIcon, XIcon, Edit3Icon} from 'vue-feather-icons'
  import {rolesComputed, branchesComputed} from '@state/helpers';

  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon
    },
    props: {
      phones: {
        type: Array,
        required: true
      },
      validation: {
        type: [Array, Object],
        required: true
      }
    },
    computed: {
      ...rolesComputed,
      ...branchesComputed
    },
    methods: {
      addPhone() {
        this.phones.push(
          {
            number: '',
            is_primary: false
          }
        );
      },

      removePhone(index) {
        this.phones.splice(index, 1)
      },

      enableEdit(index) {
        const phone = this.phones[index]
        phone.is_edit = true
        this.phones.splice(index, 1)
        this.phones.splice(index, 0, phone)
      },

      disableEdit(index) {
        const phone = this.phones[index]
        phone.is_edit = false
        this.phones.splice(index, 1)
        this.phones.splice(index, 0, phone)
      },

      handlerFilter() {
        this.$emit('input', this.phones)
      },

      changePrimary(index) {
        const phone = this.phones[index]
        if (phone && phone.is_primary) {
          this.phones.forEach((item, key) => {
            if (key !== index) {
              item.is_primary = false
            }
          })
        }
      },
    }
  }
</script>

<template>
  <div class="form-content pt-3">
    <div v-for="(phone, index) in phones" :key="index">

      <div v-if="phone.id" class="edit-form-item my-2">
        <div class="item-info">
          <div class="col-md-6 left-ct">
            <a  :href="`tel:${phone.phone}`" class="tx-value mg-b-0 text-bold tx-blue-f tx-underline">{{ phone.phone }}</a>
          </div>
          <div class="col-md-6 right-ct">
            <span v-if="phone.is_primary" class="block-status border rounded-pill pl-1 pr-3">
              <span class="status-icon status-completed"></span>
              <span class="status-text">Primary</span>
            </span>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button type="button" class="btn btn-icon button-action button-action-edit" @click="enableEdit(index)">
            <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
          </button>
          <button type="button" class="btn btn-icon button-action button-action-negative" @click="removePhone(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>

      <div v-if="!phone.id || phone.is_edit" class="main-form-group border border-radius-20 bg-gray mt-3">
        <div class="action-group mg-l-auto tw-flex-shrink-1 float-right">
          <button
            type="button"
            class="btn btn-icon button-action button-action-negative"
            @click="phone.is_edit ? disableEdit(index) : removePhone(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
        <div class="form-block">

          <div :class="['form-group', { 'is-invalid': validation['phones.' + index + '.phone'] }]">
            <label class="label-control">Phone Number*</label>
            <input v-model="phones[index].phone" type="text" class="form-control"/>
            <div class="invalid-feedback">
              {{ validation['phones.' + index + '.phone'] }}
            </div>
          </div>

          <div :class="['form-group', { 'is-invalid': validation['phones.' + index + '.is_primary'] }]">
            <label class="label-control">Phone Number Type</label>
            <div class="switch-content">
              <label class="switch">
                <input
                  v-model="phones[index].is_primary"
                  type="checkbox"
                  class="input-switch"
                  @change="changePrimary(index)">
                <span class="slider"></span>
              </label>
              <span class="value">Primary</span>
            </div>
            <div class="invalid-feedback">
              {{ validation['phones.' + index + '.is_primary'] }}
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addPhone">
        <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
        <span class="item-text">Add phone</span>
      </button>
    </div>
  </div>
</template>
